export enum UserRoles {
  TppUser = 'ROLE_USER',
  BackofficeUser = 'ROLE_LDAP'
}
